module.exports = __webpack_public_path__ + "static/img/LV.78a35066.svg";